export default "__VITE_ASSET__ia0hjimO__"